import {createSelector} from 'reselect';

const currentStreak = (state) => state.designChapter.currentStreak;

export const getCurrentStreak = createSelector(
  [currentStreak],
  (currentStreak) => currentStreak
);

const longestStreak = (state) => state.designChapter.longestStreak;

export const getLongestStreak = createSelector(
  [longestStreak],
  (longestStreak) => longestStreak
);
